import React from 'react';
import Dialog from 'components/DesignSystem/Dialog';
import useSaveFluxAutomaticPreference from 'utils/hooks/flux/automatic/useSaveFluxAutomaticPreference';
import SaveFluxAutomaticPreferenceForm from './saveFluxAutomaticPreferenceForm';

export default function SavePreferencesModal() {
  const { setShowFormModal, showFormModal } = useSaveFluxAutomaticPreference();

  return (
    <Dialog
      open={showFormModal}
      dismiss={() => { setShowFormModal(false); }}
      closeButton
    >
      <Dialog.Body>
        <SaveFluxAutomaticPreferenceForm />
      </Dialog.Body>
    </Dialog>
  );
}
